module.exports = __webpack_public_path__ + "static/umberlee-symbol-DND3_FnP-8934d694ed9bd1814676b639c1975774.webp";